module.exports = __webpack_public_path__ + "red.jpg?4376576a3af8ca48c469743a3d7ad811";